@import 'styles/mixins';
@import 'styles/variables';

.wrapper {
  @include z-index(serviceWorkerUpdateModal);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  /* Requested by russel to be $grey-90 at 25% opacity */
  background-color: rgba(43, 47, 56, 0.25);
}
.dialog {
  @include md-regular;
  box-shadow: 0 8px 24px rgba(19, 21, 26, 0.12), 0 1px 1px rgba(19, 21, 26, 0.12);
  background: var(--neutral-0);
  border-radius: 16px;
}
.main {
  padding: 16px;
}
.title {
  @include lg-semibold;
}
.details {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
.appIcon {
  width: 64px;
  height: 64px;
}
.detailsMain {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.detailTitle {
  @include md-medium;
  @include for-phone-only {
    display: none;
  }
}
.detailText {
  padding: 0;
}
.footer {
  border-top: 1px solid var(--neutral-10);
  display: flex;
  justify-content: space-between;
  padding: 16px;
  align-items: center;
  @include for-phone-only {
    justify-content: flex-end;
  }
}
.whatsNewWrapper {
  display: flex;
  align-items: center;
  gap: 4px;
  @include for-phone-only {
    display: none;
  }
}
.whatsNewWrapperMobile {
  display: none;
}
@include for-phone-only {
  .whatsNewWrapperMobile {
    display: unset;
  }
}
.footerControls {
  display: flex;
  gap: 16px;
}
